import React, { useEffect, useState } from "react";
import styled from "styled-components";
import DataTable from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";

// Corrected MUI Imports
import GetAppIcon from '@mui/icons-material/GetApp';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import { Button, Card, IconButton } from '@mui/material';

// Your local imports
import close from "../assets/closeImg.svg";
import { baseUrl } from "../../../../Constnats/constants";

Modal.setAppElement("#root");

function DataTableList() {
  const [userList, setUserList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [viewData, setViewData] = useState({});
  const [userId, setUserId] = useState(null);
  const [approveOrReject, setApproveOrReject] = useState(false);
  const [showApprovedList, setShowApprovedList] = useState(false);
  const [showRejectedList, setShowRejectedList] = useState(false);

  const columns = [
    {
      name: "Id",
      selector: (row) => row.sid,
      sortable: true,
      reorder: true,
      style: {
        width: "10%",
        flexGrow: "unset",
        minWidth: "70px",
      },
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      reorder: true,
    },
    {
      name: "Organization",
      selector: (row) => row.orgname,
      sortable: true,
      reorder: true,
    },
    {
      name: "Organization Address",
      selector: (row) => row.orgaddress,
      sortable: true,
      reorder: true,
    },
    {
      name: "State",
      selector: (row) => row.state,
      sortable: true,
      reorder: true,
    },
    {
      name: "Department",
      selector: (row) => row.deptname,
      sortable: true,
      reorder: true,
    },
    {
      name: "Head of Organization",
      selector: (row) => row.orghead,
      sortable: true,
      reorder: true,
    },
    {
      name: "Nodal Officer",
      selector: (row) => row.nodalofficer,
      sortable: true,
      reorder: true,
    },
    {
      name: "Project Name",
      selector: (row) => row.projectname,
      sortable: true,
      reorder: true,
    },
    {
      name: "Mobile No",
      selector: (row) => row.mobileno,
      sortable: true,
      reorder: true,
    },
    {
      name: "Filename",
      selector: (row) => row.fileName,
      sortable: true,
      reorder: true,
    },
    {
      name: !showApprovedList && !showRejectedList ? "Action" : "Status",
      cell: (row) => (
        <div className="Actionbtn">
          <IconButton
            onClick={() => handleView(row.sid)}
            style={{ marginRight: "5px" }}
          >
            <VisibilityIcon className="eyeicon" />
          </IconButton>
          {!showApprovedList && !showRejectedList ? (
            <Button
              className="pendingBtn"
              onClick={() => handlePending(row.sid)}
              style={{ marginRight: "5px" }}
            >
              {row.status}
            </Button>
          ) : showApprovedList && !showRejectedList ? (
            <Button className="appproveBtn" style={{ marginRight: "5px" }}>
              {row.status}
            </Button>
          ) : !showApprovedList && showRejectedList ? (
            <Button className="rejectBtn" style={{ marginRight: "5px" }}>
              {row.status}
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];
  const customStyles = {
    content: {
      maxWidth: "700px",
      width: "calc(100% - 148px)",
      height: "calc(100vh - 160px)",
      borderColor: "rgb(212, 212, 212)",
      background: "rgb(255, 255, 255)",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      position: "relative",
      borderRadius: "15px",
      overflow: "hidden",
    },
  };
  const customApprove = {
    content: {
      top: "50% ",
      borderRadius: "15px",
      left: "50% ",
      transform: "translate(-50%, -50%)",
      right: "auto",
      bottom: "auto",
      width: "100%",
      minHeight: "160px",
      maxHeight: "240px",
      maxWidth: "400px",
      overflow: "hidden",
      background: "0% 0% no-repeat padding-box padding-box rgb(255, 255, 255)",
      boxShadow: "rgba(42, 39, 39, 0.11) 0px 3px 6px",
      border: "0.5px solid rgb(212, 212, 212)",
    },
  };
  useEffect(() => {
    getUserListData();
  }, []);

  const getUserListData = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/nicdsignrequests`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      setUserList(result);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const handlePending = (id) => {
    setApproveOrReject(true);
    setUserId(id);
    console.log("Approve request for id:", id);
  };

  const convertToCSV = (data) => {
    const csv = data.map((row) =>
      Object.values(row)
        .map((value) => JSON.stringify(value))
        .join(",")
    );
    return csv.join("\n");
  };

  // Function to trigger CSV download
  const downloadCSV = () => {
    const csvData = convertToCSV(userList);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const csvUrl = URL.createObjectURL(blob);
    const tempLink = document.createElement("a");
    tempLink.href = csvUrl;
    tempLink.setAttribute("download", "userlist.csv");
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  };

  // Export button component
  const ExportButton = () => (
    <Button className="Exportcv" color="primary" onClick={downloadCSV}>
      <GetAppIcon />
      Download
    </Button>
  );
  const Title = () => (
    <div>
      <h2 className="HeaderStyle">Data List</h2>
      <p className="subHeader">{filteredUserList.length} entries found</p>
    </div>
  );
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };
  const filteredUserList = userList
    .filter((user) => {
      if (showApprovedList) {
        return user.status === "approved";
      } else if (showRejectedList) {
        return user.status === "rejected";
      } else {
        return user.status === "pending";
      }
    })
    .filter(
      (
        user // Apply the search filter
      ) =>
        Object.values(user).some(
          (value) =>
            value &&
            value.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

  const handleView = (id) => {
    const data = userList.find((user) => user.sid === id);
    if (data) {
      setViewData(data);
      setModalIsOpen(true);
      console.log("View details for id:", id);
    } else {
      console.log("No data found for id:", id);
    }
  };

  const closeModal = () => setModalIsOpen(false);

  const handleDownload = async (id, filename) => {
    try {
      const response = await fetch(
        `${baseUrl}/download/${id}/${filename}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("There was a problem with the download operation:", error);
    }
  };
  const handleSaveApprove = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/approve/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      setApproveOrReject(false);
      getUserListData();
      toast.success("Approval successful");
      console.log("Approval successful");
    } catch (error) {
      console.error("Error during fetch:", error);
    }
  };

  const handleCancelApproveorReject = () => {
    setApproveOrReject(false);
  };
  const handleSaveReject = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/reject/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      setApproveOrReject(false);
      getUserListData();
      toast.success(" Successfully rejected");
      console.log("reject successful");
    } catch (error) {
      console.error("Error during fetch:", error);
    }
  };
  const handleApprovedDataListClik = () => {
    console.log("ApprovedListClicked");
    setShowApprovedList(true);
    setShowRejectedList(false);
  };
  const handleRejectedDataListClik = () => {
    setShowRejectedList(true);
    setShowApprovedList(false);
  };
  const handlePendingDataListClick = () => {
    setShowRejectedList(false);
    setShowApprovedList(false);
  };

  return (
    <Wrapper>
      <div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Example Modal"
          style={customStyles}
        >
          <div className="HeadingStyle">
            <div>Details for User ID: {viewData.sid}</div>
            <div style={{ minWidth: "29px" }}>
              <img
                src={close}
                alt="close"
                onClick={closeModal}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <div className="modalInnerWrappers">
            <div className="HeadingStyle">RequestFile details</div>
            <div className="modalSubHeadingWrap uploadFileStylemodal">
              <div>
                <h6>Uploaded requestfile</h6>
                <div className="tagWrapper">
                  <p>{viewData.fileName}</p>
                </div>
              </div>
              <div
                className="btn-slide2"
                onClick={() => handleDownload(viewData.sid, viewData.fileName)}
              >
                <span className="circle2">
                  <i className="material-icons iconStyleDwnl"> download </i>
                </span>
                <span className="title2">Download</span>
                <span className="title-hover2">Click here</span>
              </div>
            </div>
            <div className="HeadingStyle">Organization details</div>
            <div className="modalWrap">
              <div className="modalSubHeadingWrap">
                <h6>Organization Type</h6>
                <div className="tagWrapper">
                  <p>{viewData.orgtype}</p>
                </div>
              </div>
              {viewData.orgType === "Others" && (
                <div className="modalSubHeadingWrap">
                  <h6>If Other</h6>
                  <div className="tagWrapper">
                    <p>{viewData.othertype}</p>
                  </div>
                </div>
              )}

              <div className="modalSubHeadingWrap">
                <h6>Organization Name</h6>
                <div className="tagWrapper">
                  <p>{viewData.orgname}</p>
                </div>
              </div>
              <div className="modalSubHeadingWrap">
                <h6>State</h6>
                <div className="tagWrapper">
                  <p>{viewData.state}</p>
                </div>
              </div>
              <div className="modalSubHeadingWrap">
                <h6>Organization Address</h6>
                <div className="tagWrapper">
                  <p className="addressStyle">{viewData.orgaddress}</p>
                </div>
              </div>
              <div className="modalSubHeadingWrap">
                <h6>Office phone no</h6>
                <div className="tagWrapper">
                  <p>{viewData.phoneno}</p>
                </div>
              </div>
              <div className="modalSubHeadingWrap">
                <h6>Head of organization</h6>
                <div className="tagWrapper">
                  <p>{viewData.orghead}</p>
                </div>
              </div>
              <div className="modalSubHeadingWrap">
                <h6>Ministry/Department</h6>
                <div className="tagWrapper">
                  <p>{viewData.deptname}</p>
                </div>
              </div>
            </div>
            <div className="HeadingStyle">Project details</div>
            <div className="modalWrap">
              <div className="modalSubHeadingWrap">
                <h6>Project Name</h6>
                <div className="tagWrapper">
                  <p>{viewData.projectname}</p>
                </div>
              </div>
              <div className="modalSubHeadingWrap">
                <h6>Project Description</h6>
                <div className="tagWrapper addressStyle">
                  <p>{viewData.projectdesc}</p>
                </div>
              </div>
            </div>
            <div className="HeadingStyle">Nodal officer details</div>
            <div className="modalWrap">
              <div className="modalSubHeadingWrap">
                <h6>Name</h6>
                <div className="tagWrapper">
                  <p>{viewData.nodalofficer}</p>
                </div>
              </div>
              <div className="modalSubHeadingWrap">
                <h6>Designation</h6>
                <div className="tagWrapper">
                  <p>{viewData.nodaldesignation}</p>
                </div>
              </div>
              <div className="modalSubHeadingWrap">
                <h6>Mobile no</h6>
                <div className="tagWrapper">
                  <p>{viewData.mobileno}</p>
                </div>
              </div>
              <div className="modalSubHeadingWrap">
                <h6>Email</h6>
                <div className="tagWrapper">
                  <p>{viewData.email}</p>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
      <div>
        <Modal
          isOpen={approveOrReject}
          onRequestClose={closeModal}
          contentLabel="Example Modal"
          style={customApprove}
        >
          <div className="gridContent">
            Are you sure want to Approve or Reject
            <p>User ID:{userId}</p>
          </div>
          <div className="k-dialog-buttongroup ">
            <div>
              <button
                className="cancelModal"
                onClick={handleCancelApproveorReject}
              >
                {" "}
                Cancel
              </button>
            </div>
            <div className="approveDelt">
              <button className="deleteModal" onClick={handleSaveApprove}>
                Approve
              </button>
              <button className="deleteModal reject" onClick={handleSaveReject}>
                Reject
              </button>
            </div>
          </div>
        </Modal>
      </div>

      <Card>
        <ToastContainer />
        <StyledDataTable
          title={<Title />}
          columns={columns}
          data={filteredUserList}
          defaultSortField="Id"
          defaultSortFieldId={1}
          sortIcon={<ArrowDownward />}
          pagination
          fixedHeader
          highlightOnHover
          actions={<ExportButton />}
          subHeader
          subHeaderComponent={
            <div className="btnlistAlign">
              <div className="buttonGroup">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlePendingDataListClick}
                >
                  Pending List
                </Button>
                <ApprovedButton
                  variant="contained"
                  color="inherit"
                  onClick={handleApprovedDataListClik}
                >
                  Approved List
                </ApprovedButton>
                <RejectedButton
                  variant="contained"
                  color="secondary"
                  onClick={handleRejectedDataListClik}
                >
                  Rejected List
                </RejectedButton>
              </div>
              <div className="serchDiv">
                <SearchIcon className="searchIcon" />
                <input
                  type="text"
                  placeholder="Search"
                  className="form-control serachBar "
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>
            </div>
          }
          className="DataTable"
        />
      </Card>
    </Wrapper>
  );
}

export default DataTableList;

const ApprovedButton = styled(Button)``;

const RejectedButton = styled(Button)``;

const Wrapper = styled.div`
  .MuiButton-colorInherit {
    color: #fff;
    background-color: #29bd4d;

    &:hover {
      background-color: #3fb590;
    }
  }
  .MuiCard-root {
    background-color: #f4f5f7;
    padding: 10px 40px;
    box-shadow: none !important;

    header {
      background-color: #f4f5f7;
      padding: 0px 0px 15px 0px;
      width: 100%;
      justify-content: space-between !important;
    }
  }
  @media only screen and (min-width: 300px) and (max-width: 700px) {
    .btnlistAlign {
      display: block !important;
      .buttonGroup {
        button {
          margin-bottom: 10px !important;
          font-size: 11px !important;
        }
      }
    }
  }
  .btnlistAlign {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .buttonGroup {
      display: flex;
      align-items: center;
      gap: 10px;
      button {
        text-transform: capitalize !important;
      }
    }
  }
  .rdt_Pagination {
    margin-top: 10px;
  }
  .rdt_TableCol[data-column-id="1"] {
    flex-grow: unset;
    min-width: 70px;
  }
  .rdt_TableCell[data-column-id="2"] {
    color: #1d39c4;
  }
  .rdt_TableCell[data-column-id="11"] {
    color: #1d39c4;
  }
  .rdt_TableCol[data-column-id="12"] {
    flex-grow: 1;
  }
  .rdt_TableCell[data-column-id="12"] {
    flex-grow: 1;
  }
  .rdt_TableCell {
    font-size: 13.5px;
  }
  .rdt_TableRow {
    padding: 10px 0px;
    border-bottom-color: rgb(135 149 255 / 29%);
    &:hover {
      background-color: #a6bef773 !important;
    }
  }
  .rdt_TableHeader {
    background-color: #f4f5f7;
    min-height: 45px;
    padding: 0px;
    align-items: center;
  }
  .HeaderStyle {
    text-align: left;
    font-size: 30px;
    font-weight: 700;
    letter-spacing: 1px;
    margin-bottom: 0px;
  }
  .subHeader {
    margin-bottom: 0px;
    text-align: left;
    font-size: 16px;
    color: #4d4d4d;
  }
  .Exportcv {
    background-color: #5469d4;
    padding: 6px 10px;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: capitalize;
    &:hover {
      background-color: #1d39c4;
    }
  }
  .MuiSvgIcon-root {
    width: 20px;
  }
  .DataTable {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  }
  .DataTable::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  .DataTable::-webkit-scrollbar-track {
    background: #e5e5e5;
  }

  .DataTable::-webkit-scrollbar-thumb {
    background: #6a9ef6;
    border-radius: 5px;
  }

  .DataTable::-webkit-scrollbar-thumb:hover {
    background: #6a9ef6;
  }
  .serchDiv {
    width: 25%;
    position: relative;

    .searchIcon {
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
      color: #5469d4;
    }
  }
  .serachBar {
    padding-left: 30px !important;
  }
  .form-control:focus {
    color: #212529;
    background-color: #fff;
    border-color: #9aa5fa;
    outline: none;
    box-shadow: none;
  }
  .form-control {
    border-color: #9aa5fa;
  }
  .rdt_TableHeadRow {
    background: #6a9ef6;
    color: #000;
    font-size: 13px;
  }

  @media only screen and (min-width: 300px) and (max-width: 700px) {
    .serchDiv {
      width: 100%;
    }
  }
  .Actionbtn {
    display: flex;
    justify-content: center;
    align-items: center;
    .eyeicon {
      width: 15px;
      color: #1d39c4;
    }
    button {
      padding: 0px;
      font-size: 12px;
    }
    .appproveBtn {
      display: inline-block;
      border-radius: 12px;
      text-align: center;
      padding: 4px;
      font-size: 12px;
      color: #0f7233;
      background: rgb(80 226 168 / 48%);

      text-transform: capitalize;
      padding: 2px 5px;
      &:hover {
        color: #0f7233;
        background: rgb(80 226 168 / 48%);
      }
    }
    .pendingBtn {
      display: inline-block;
      border-radius: 12px;
      text-align: center;
      padding: 4px;
      font-size: 12px;
      color: #113a6a;
      background: rgb(190 219 244 / 74%);
      text-transform: capitalize;
      padding: 2px 5px;
      &:hover {
        color: #ffffff;
        background: rgb(16 91 155);
      }
    }
    .rejectBtn {
      display: inline-block;
      border-radius: 12px;
      text-align: center;
      padding: 4px;
      font-size: 12px;
      color: rgb(255, 0, 0);
      background: rgb(249 211 211 / 77%);

      text-transform: capitalize;
      padding: 2px 5px;
      &:hover {
        color: rgb(255, 0, 0);
        background: rgb(249 211 211 / 77%);
      }
    }
  }
`;
const StyledDataTable = styled(DataTable)``;